import * as api from "../api";

export const PackageService = {
  // getPackages,
  selectPackages,
  changePackage,
  getPackagesForUsers,
};

async function getPackagesForUsers(page, rowsPerPage) {
  try {
    const { data } = await api.getPackagesForUsers(page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

// async function getPackages() {
//   try {
//     const { data } = await api.getPackages();
//     return { isSuccess: true, data: data };
//   } catch (error) {
//     return { isSuccess: false, data: error };
//   }
// }

async function selectPackages(formData) {
  try {
    const { data } = await api.selectPackages(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function changePackage(formData) {
  try {
    const { data } = await api.changePackage(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}
